import React, {useState} from 'react';
import clsx from "clsx";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import {Divider, Paper} from "@mui/material";
import ListItemText from "@mui/material/ListItemText";
import {BaseStyle} from "../../../../styles/shared/BaseStyle";
import EventTwoToneIcon from '@mui/icons-material/EventTwoTone';
import EventAvailableTwoToneIcon from '@mui/icons-material/EventAvailableTwoTone';
import Typography from "@mui/material/Typography";
import BathtubTwoToneIcon from "@mui/icons-material/BathtubTwoTone";


const FocolaiDrawer = ({selectMenuItem, stato,}) => {
	const classes = BaseStyle();
	const [open, setOpen] = useState(true);
	
	const handleDrawerOpenClose = () => {
		setOpen(!open);
	};
	
	return (
        <React.Fragment>
            <Paper
				className={clsx(classes.drawer, classes.roundBorder, open ? classes.openDrawer : classes.closedDrawer)}>
				<div style={{display: "flex", justifyContent: "center"}}>
					<Tooltip title={open ? "Comprimi menù" : "Espandi menù"}>
						<IconButton onClick={handleDrawerOpenClose} size="large">
							{!open ? <ChevronRightIcon/> : <ChevronLeftIcon/>}
						</IconButton>
					</Tooltip>
				</div>
				<List>
					<ListItem button className={classes.roundBorder} selected={stato === "ATTIVO"}
					          onClick={() => selectMenuItem("ATTIVO")}>
						<ListItemIcon>
							<EventTwoToneIcon/>
						</ListItemIcon>
						<ListItemText primary={"In corso"}
						              secondary={<Typography color={"textSecondary"} variant={"body2"}
						                                     style={{width: 190, whiteSpace: "pre-wrap"}}>Esiste
							              almeno una
							              quarantena/isolamento attiva nel
							              focolaio</Typography>}/>
					</ListItem>
					<ListItem button className={classes.roundBorder} selected={stato === "INATTIVO"}
					          onClick={() => selectMenuItem("INATTIVO")}>
						<ListItemIcon>
							<EventAvailableTwoToneIcon/>
						</ListItemIcon>
						<ListItemText primary={"Conclusi"} secondary={<Typography color={"textSecondary"} variant={"body2"}
						                                                          style={{width: 190, whiteSpace: "pre-wrap"}}>Tutte
							le quarantene/isolamenti sono conclusi</Typography>}/>
					</ListItem>
				</List>
				<Divider/>
				<List>
					<ListItem button className={classes.roundBorder} selected={stato === "In gestione"}
					          onClick={() => selectMenuItem("In gestione")}>
						<ListItemIcon>
							<BathtubTwoToneIcon/>
						</ListItemIcon>
						<ListItemText primary={"In gestione"} secondary={<Typography color={"textSecondary"} variant={"body2"}
						                                                             style={{width: 190, whiteSpace: "pre-wrap"}}>Il
							focolaio lo sta lavorando un operatore</Typography>}/>
					</ListItem>
				</List>
			</Paper>
        </React.Fragment>
    );
};

export default React.memo(FocolaiDrawer)
